


















































import { Component, Prop, Vue } from 'vue-property-decorator';
import population from '@/interfaces/population.ts';

@Component({
  methods: {
    onRemove(index) {
      const that: any = this;
      that.$emit('remove', index);
    },
    onStart() {
      const that: any = this;
      that.$emit('start', true);
    },
  },
})
export default class PopulationsTable extends Vue {
  @Prop() private populations!: population[];
}
